module.exports = __webpack_public_path__ + "static/media/salisbury-22.dac212e2.jpg";